import Axios, { InternalAxiosRequestConfig } from 'axios';

export interface ApiClientConfig {
  baseURL: string;
  getAuthToken?: () => Promise<string | undefined>;
  onUnauthorized?: () => void;
  onForbidden?: () => void;
}

export const configureApiClient = (apiConfig: ApiClientConfig) => {
  const api = Axios.create({
    baseURL: apiConfig.baseURL,
  });
  api.interceptors.request.use(authRequestInterceptor);
  api.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (error.response?.status === 401) {
        apiConfig.onUnauthorized?.();
      } else if (error.response?.status === 403) {
        apiConfig.onForbidden?.();
      }

      return Promise.reject(error);
    }
  );

  async function authRequestInterceptor(config: InternalAxiosRequestConfig) {
    if (config.headers && apiConfig.getAuthToken) {
      config.headers.Accept = 'application/json';
      const token = await apiConfig.getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  }

  return api;
};
